import React from 'react';

import Grid from "@mui/material/Grid";

import CustomerNumber from "../components/CustomerNumber";
import CarrierServiceIdField from "./CarrierServiceIdField";
import ReturnCarrierServiceIdField from "./ReturnCarrierServiceIdField";

function Nshift(props) {
    return (
        <Grid container columnSpacing={2} rowSpacing={2}>
            <Grid item xs={6}>
                <CarrierServiceIdField />
            </Grid>
            <Grid item xs={6}>
                <ReturnCarrierServiceIdField />
            </Grid>
            <Grid item xs={12}>
                <CustomerNumber />
            </Grid>
        </Grid>
    );
}

export default Nshift;
